/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';
import { toast } from 'react-toastify';

import { request } from '@mairistem/tools';

import { getInseePacsPurge, getInseePacsRelances } from '@/routes';

/** Entités déjà traitées depuis l'ouverture de l'application */
const entitesTraitees = new Set<number | string>();

const messageErreur = (error: any) =>
  error?.response?.data?.message ?? error?.data?.message ?? null;

/**
 * Maintenance du transfert INSEE, lancée une fois par entité à l'ouverture du
 * module comme WinDev au démarrage : relance des lots restés sans accusé de
 * réception la veille, puis purge à 183 jours. L'API ne peut pas le faire
 * seule : la base de la mairie n'est connue que par la requête.
 */
const useMaintenanceInsee = () =>
  React.useCallback(async (identifiantEntite: number | string) => {
    if (_.isNil(identifiantEntite) || entitesTraitees.has(identifiantEntite)) {
      return;
    }
    entitesTraitees.add(identifiantEntite);

    try {
      const { data: relances = [] } =
        ((await request.post(getInseePacsRelances())) as any) ?? {};

      if (!_.isEmpty(relances)) {
        toast.info(
          relances.length === 1
            ? `Lot INSEE n°${relances[0].numero} relancé`
            : `${relances.length} lots INSEE relancés`,
        );
      }
    } catch (error) {
      const message = messageErreur(error);
      toast.warning(
        message
          ? `Relance des lots INSEE impossible : ${message}`
          : 'Relance des lots INSEE impossible',
      );
    }

    try {
      await request.post(getInseePacsPurge());
    } catch {
      // Sans conséquence pour l'utilisateur : refaite à la prochaine ouverture.
    }
  }, []);

/** Réservé aux tests : oublie les entités déjà traitées */
export const reinitialiserMaintenanceInsee = () => entitesTraitees.clear();

export default useMaintenanceInsee;
